import { Theme } from "@mui/material/styles";
import { brandBlue, validationRed } from "./colors";

export const commonStyles = (theme: Theme) => ({
  label: {
    color: theme.palette.primary.main,
    fontWeight: 200,
  },
  groupLabel: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  saveButton: {
    textTransform: "none",
    fontWeight: "bold",
  },
  cancelButton: {
    background: theme.palette.common.white,
    textTransform: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  deleteButton: {
    background: theme.palette.common.white,
    textTransform: "none",
    color: validationRed.toString(),
    fontWeight: "bold",
  },
  headerButton: {
    color: theme.palette.primary.contrastText,
    textTransform: "none",
  },
  headerButtonIcon: {
    fill: theme.palette.primary.contrastText,
  },
  whiteIcon: {
    fill: theme.palette.common.white,
  },
  subjectTable: {
    marginBottom: "1rem",
    marginTop: "0.5rem",
  },
  subjectTableRow: {
    height: 36,
  },
  subjectTableName: {
    color: brandBlue.toString(),
    fontWeight: "bold",
  },
});

export const commonSearchModalStyles = (theme: Theme) => ({
  appBar: {
    position: "relative",
  },
  closeButton: {
    background: "gray",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  textField: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  adornment: {},
  icon: {
    fill: theme.palette.primary.contrastText,
  },
  label: {
    color: theme.palette.primary.contrastText,
  },
});
